import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoicingSettingsFormPlaceholder } from '../../../../elements/InvoicingSettingsFormPlaceholder'

export const QuoteSettingsForm = (): ReactElement => {
  const { t } = useTranslation()

  return <InvoicingSettingsFormPlaceholder title={t('quote')} />
}
